/* eslint-disable array-callback-return */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import regex from '../../constants/system.keys';

const layout = {
  wrapperCol: { span: 18 },
};

const CreateMarkerComponent = ({ onCreateGroup, dataDevice, onListDevice, onUpdateGroup, total }) => {
  const dispatch = useDispatch();
  const { camerasSelect, namespace, isAuth, listDeviceByGroupId } = useSelector((state) => state);
  const [address, setAddress] = useState();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();

  useEffect(() => {
    forceUpdate({});
  }, []);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10000);
  const [requestId, setTimeRequest] = useState(new Date().getTime());
  const [isBlock, setIsBlock] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [dataArr1, setDataArr1] = useState([])
  const [dataValueSelect, setDataValueSelect] = useState([])
  const [key, setKey] = useState(Math.random());
  const nameRef = useRef(null);
  const [filteredCameras, setFilteredCameras] = useState([]);
  const selectedCamerasBeforeSelectAll = useRef([]);

  const getDeviceByPage = useCallback(
    (page, size) => {
      const dataTimeRequest = new Date().getTime();
      let data1 = {
        namespace,
        deviceType: 'camera',
        timeRequest: dataTimeRequest,
        page,
        size,
        tag: 'select_device'
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: dataTimeRequest,
        body: JSON.stringify(data1),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, total);
    }
  }, [getDeviceByPage, isAuth, namespace, page, pageSize, total]);


  useEffect(() => {
    if (dataDevice) {
      form.setFieldsValue({
        name: dataDevice.name,
        type: dataDevice.type
      });
    } else {
      form.setFieldsValue({
        name: "",
        type: "private"
      });
    }
    setDataArr1((camerasSelect && camerasSelect.data) || []);
    if (!!camerasSelect?.data?.length && dataDevice && dataDevice.devices && dataDevice.devices.length > 0) {
      const allDevices = dataDevice?.devices || [];
      const validDevices = allDevices?.filter(item => camerasSelect?.data?.some(camera => camera.serial === item.serial));
      setDataList(validDevices.map(item => ({
        serial: item.serial
      })))
      setDataArr(validDevices)
      setDataValueSelect(validDevices.map(item => item.serial));
      selectedCamerasBeforeSelectAll.current = validDevices.map(item => item.serial);

      if (!!dataDevice?.devices?.length && dataDevice?.devices?.length === camerasSelect?.data?.length) {
        setDataValueSelect(pre => [...pre, 'selectAll']);
      }
    }
  }, [camerasSelect, dataDevice, form, listDeviceByGroupId]);

  const onFinish = (values) => {
    form.resetFields();
    if (dataDevice?.id) {
      onUpdateGroup(values, dataList, dataDevice.id);
    } else {
      onCreateGroup(values, dataList);
    }
    onListDevice()
    return setAddress(null);
  };
  useEffect(() => {
    return () => {
      setAddress(null);
      setIsBlock(false);
    };
  }, []);

  useEffect(() => {
    if (nameRef.current) {
      setTimeout(() => { nameRef.current.input.focus() }, 1)
    }
  }, [nameRef]);

  const onDelete = (value) => {
    const data = [...dataList]
    const data1 = [...dataArr]
    const data2 = [...dataValueSelect]
    const sub = data?.filter((item) => item.serial !== value.serial) ?? []
    setDataList(sub)
    const sub1 = data1?.filter((item) => item.serial !== value.serial) ?? []
    setDataArr(sub1)
    const sub2 = data2?.filter((item) => item !== value.serial) ?? []
    setDataValueSelect(sub2)
  }

  const onChangeSearch = (value) => {
    const isAllOptionSelected = isAllChecked(filteredCameras, value);
    let dataItems = [];
    // eslint-disable-next-line no-unused-expressions
    value?.map(item => {
      const dataItemTemp = dataArr1?.find(x => x.serial === item)
      if (dataItemTemp) {
        dataItems = [
          ...dataItems,
          dataItemTemp
        ]
      }
    })

    setDataValueSelect((isAllOptionSelected ? [...new Set(value.concat('selectAll'))] : value.filter(item => item !== 'selectAll')) ?? [])
    setDataArr([
      ...dataItems
    ])
    const dataSerials = dataItems?.map(item => ({ serial: item.serial })) ?? []
    setDataList([...dataSerials])
  }

  const isAllChecked = (options, selectedOptions) => {
    return options.every(option => selectedOptions.includes(option));
  }

  const onSearchCamera = (keyword) => {
    const serials = dataArr1?.filter(item => item.name?.toLowerCase()?.includes((keyword || '').toLowerCase()))?.map(item => item.serial);
    setFilteredCameras(serials);
    const isAllOptionChecked = isAllChecked(serials, dataValueSelect);
    setDataValueSelect(isAllOptionChecked ? [...new Set([...dataValueSelect, 'selectAll'])] : dataValueSelect.filter(item => item !== 'selectAll'));
  }

  const onSelectCamera = (value) => {
    if (value === 'selectAll') {
      selectedCamerasBeforeSelectAll.current = dataValueSelect;
      const serials = [...new Set([...(filteredCameras || []), ...(dataValueSelect || []), 'selectAll'])];
      onChangeSearch(serials);
    }
  }

  const onDeselectCamera = (value) => {
    if (value === 'selectAll') {
      const serials = dataValueSelect.filter(item => selectedCamerasBeforeSelectAll.current.includes(item) && item !== 'selectAll');
      onChangeSearch(serials);
    }
  }

  useEffect(() => {
    onSearchCamera('')
  }, [dataArr1]);

  return (
    <div className="create-marker-component">
      <Form className="select-placeholder" form={form} {...layout} onFinish={onFinish} name="form_in_modal">
        <Form.Item
          style={{ justifyContent: 'center' }}
          name="name"
          rules={[
            {
              required: true,
              message: t('Please input the name of the group!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input ref={nameRef} placeholder={t('Name of the group')} />
        </Form.Item>

        <Form.Item
          style={{ justifyContent: 'center' }}
          name="type"
        >
          <Select className="group-camera__select-type">
            <Select.Option value='public'>Public</Select.Option>
            <Select.Option value='private'>Private</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          style={{ justifyContent: 'center' }}
        >
          <Select
            className="form-select"
            mode="multiple"
            showSearch
            key={key}
            value={dataValueSelect}
            optionLabelProp="label"
            placeholder={t('Add cameras')}
            optionFilterProp="children"
            filterOption={(input, option) => option.children?.trim()?.toLowerCase()?.includes(input.toLowerCase()) || option.value === 'selectAll'}
            onChange={onChangeSearch}
            disabled={dataArr?.length > 1000}
            autoClearSearchValue={false}
            onSearch={onSearchCamera}
            onSelect={onSelectCamera}
            onDeselect={onDeselectCamera}
            onBlur={() => {
              onSearchCamera('');
              const isCheckAll = isAllChecked(dataArr1?.map(item => item.serial), dataValueSelect);
              setDataValueSelect(isCheckAll ? [...dataValueSelect, 'selectAll'] : dataValueSelect.filter(item => item !== 'selectAll'));
            }}
          >
            <>
              {
                !!(filteredCameras && filteredCameras.length) && (<Select.Option
                  key={'selectAll'}
                  value={'selectAll'}
                  label={t('Add cameras')}
                >
                  {t('Select All')}
                </Select.Option>)
              }
              {dataArr1.map((d, index) => <Select.Option
                key={`${d.serial}-${index}`}
                value={d.serial}
                label={t('Add cameras')}
              >{d.name}</Select.Option>)}
            </>
          </Select>
        </Form.Item>
        <div style={{ textAlign: "center" }}>{t('Cameras')}</div>
        <div
          style={{
            padding: '10px 11px 0px',
            overflow: 'auto',
            height: '330px',
            marginBottom: "10px"
          }}
        >
          {dataArr && dataArr.length > 0 && dataArr.map((item) => {
            const check = dataList && dataList.length > 0 && dataList.filter((fil) => item.serial === fil.serial) || []
            return (
              <div
                key={item.serial}
                style={{
                  padding: '15px 0',
                  borderTop: '1px solid #303030',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '13px',
                    fontWeight: 600
                  }}
                >
                  {item.name}
                </span>
                <DeleteOutlined style={{ marginRight: '10px' }} onClick={() => onDelete(item)} />
              </div>
            )
          })}
        </div>
        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button htmlType="submit" disabled={isBlock}>
              {dataDevice ? t('Update') : t('Create')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default CreateMarkerComponent;
